<template>
  <div v-if="modal.backdrop">
    <div class="modal fade"
      tabindex="-1"
      style="display: block"
      role="dialog"
      v-if="modal.open"
      :class="modal.open ? 'show':''"
    >
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ config.title }}</h5>
            <button type="button" class="close" @click="close()" v-html="ic('close')"/>
          </div>
          <form @submit.prevent="_submit">
            <div class="modal-body default">
              <div class="row">
                <div class="col-12 form-group">
                  <label for="kode-perusahaan">Kode Perusahaan</label>
                  <input
                      v-model="input.kode_mitra"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Kode Perusahaan"
                      id="kode-perusahaan" required>
                </div>
              </div>
              <div class="row">
                <div class="col-12 form-group">
                  <label for="nama-perusahaan">Nama Perusahaan</label>
                  <input
                      v-model="input.perusahaan"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Nama Perusahaan"
                      id="nama-perusahaan" required>
                </div>
              </div>
              <div class="row">
                <div class="col-6 form-group">
                  <label for="nama-pkp">Nomor Telepon</label>
                  <input
                      v-model="input.telp"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Nomor Telepon"
                      id="nama-pkp" required>
                </div>
                <div class="col-6 form-group">
                  <label for="alamat-pkp">Alamat</label>
                  <input
                      v-model="input.alamat"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Alamat"
                      id="alamat-pkp" required>
                </div>
              </div>
              <div class="row">
                <div class="col-6 form-group">
                  <label for="nama-pkp">Kabupaten</label>
                  <input
                      v-model="input.kabupaten"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Kabupaten"
                      id="kabupaten" required>
                </div>
                <div class="col-6 form-group">
                  <label for="alamat-pkp">Kode Pos</label>
                  <input
                      v-model="input.fax"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Kode Post"
                      id="kode_pos" required>
                </div>
              </div>
              <div class="row">
                <div class="col-12 form-group">
                  <label for="npwp">NPWP</label>
                  <input
                      v-model="input.npwp"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan npwp"
                      id="npwp" >
                </div>
              </div>
              <div class="row">
                <div class="col-6 form-group">
                  <label for="nama-pkp">Nama PKP</label>
                  <input
                      v-model="input.nama_pkp"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Nama PKP"
                      id="nama-pkp">
                </div>
                <div class="col-6 form-group">
                  <label for="alamat-pkp">Alamat PKP</label>
                  <input
                      v-model="input.alamat_pkp"
                      type="text"
                      class="form-control"
                      placeholder="Inputkan Alamat PKP"
                      id="alamat-pkp">
                </div>
              </div>
              <div class="row">
                <div class="col-6 form-group">
                  <label for="min_order">Min. Order Value</label>
                  <input
                      v-model="input.minimal_order"
                      type="number"
                      class="form-control"
                      placeholder="Inputkan minimal order value "
                      id="min_order_value" required>
                </div>
                <div class="col-6 form-group">
                  <label for="min_order_sku">Min. Order SKU</label>
                  <input
                      v-model="input.minimal_order_sku"
                      type="number"
                      class="form-control"
                      placeholder="Inputkan minimal order value SKU "
                      id="min_order_sku" required>
                </div>
              </div>
              <div class="modal-footer p-0">
                <button
                  @click="close()"
                  type="button"
                  class="btn btn-white"
                  v-html="'Tutup'">
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  v-html="'Simpan'"
                ></button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "Form",
  props: {
    config: {
        view: false,
        title: "Modal Title"
    },
    isSubmit: false,
    initData: {},
  },    
  mixins: [helper],
  data(){
    return{
      modal: {
        open: false,
        backdrop: false,
        title: ""
      },
      input:{
        id: '',
        kode_mitra: '',
        perusahaan: '',
        alamat: '',
        telp: '',
        fax: '',
        kabupaten: '',
        minimal_order: 0,
        minimal_order_sku: 0,
        created_at: '',
        updated_at: '',
        npwp: '',
        nama_pkp: '',
        alamat_pkp: '',
      }
    }
  },
  methods: {
    _submit(){  
      this.$emit("submit", this.input);
      this.resetInput();
      this.close();
    },
    resetInput(){
      this.input= {
        id: '',
        kode_mitra: '',
        perusahaan: '',
        alamat: '',
        telp: '',
        fax: '',
        kabupaten: '',
        minimal_order: 0,
        minimal_order_sku: 0,
        created_at: '',
        updated_at: '',
        npwp: '',
        nama_pkp: '',
        alamat_pkp: '',
      }
    },
    close(){
      this.$emit("update:config", { view: false, title:"", initData: {}});
    }
  },
  watch:{
    "config.view":function(view){
      this.modal.backdrop = view;
        setTimeout(() => {
            this.modal.open = view;
        },100)
    },
    initData: function (data) {
      if (data !== null) {
        for (const key in this.input) {
          this.input[key] = data[key];
        }
      }
    },
  }
}
</script>